import React, { useState, useEffect } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import PrimaryButton from "../../elements/primary-button";
import Dropdown from "../../elements/dropdown";
import Heading from "../../elements/heading";
import "./style.scss";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { selectMarketBannerState } from "../../selectors/application";
import { changeMarketDetector } from "../../redux/actions/marketDetector";
import { isEmptyObject } from "../../utils/siteUtils";

const MarketDetector = ({ fields, changeMarketDetector, showMarketBanner, lang }) => {
  const [selectItem, setSelectItem] = useState({});
  const [options, setOptions] = useState([]);

  const [isShow, setIsShow] = useState(false);
  let marketCookieName = "market-detector-selected-value";
  let userLang = "";

  useEffect(() => {
    getOptions();
  }, []);

  useEffect(() => {
    let marketDetectorCookie = cookie.load(marketCookieName);
  }, [options]);

  const getSelectedMarketOption = code => {
    const _slecteItem = options.find(x => x.code.toLowerCase() === code.toLowerCase());
    setSelectItem(_slecteItem);
  };

  let setCookie = (_name, _value) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    cookie.save(_name, _value, {
      path: `/`,
      expires
    });
  };

  const getOptions = () => {
    let { regions } = fields;

    if (regions?.fields?.regions) {
      let _options = [];
      regions.fields.regions.forEach((item, index) => {
        let { country, language, defaultLanguage } = item.fields;
        let cn = country?.fields?.phrase?.value;
        let defaultLang = defaultLanguage?.fields?.phrase?.value;
        language &&
          language.forEach((lang, key) => {
            let ln = lang?.fields?.phrase && lang?.fields?.phrase.value;
            let code = cn ? `${ln.toLowerCase()}-${cn}` : ln.toLowerCase();

            _options.push({
              value: `${country?.fields?.key.value || "Global"} ${lang?.fields.key && lang?.fields.key.value}`,
              code,
              country: cn,
              defaultLanguage: defaultLang
            });
          });
      });
      setOptions(_options);
    }
  };

  let marketsDropdown = {
    placeholder: fields.placeholder && fields.placeholder.value,
    options: options,
    selectedOption: selectItem,
    onChange: selectedOption => {
      if (!isEmptyObject(selectedOption)) {
        setSelectItem(selectedOption);
      }
    }
  };

  let switchCTA = {
    link: {
      value: {
        text: fields.switchButtonText && fields.switchButtonText.value
      }
    },
    colorScheme: fields.switchColorScheme,
    iconName: fields.switchIcon,
    width: "auto",
    callback: () => {
      let cookieValue = selectItem && selectItem?.code;
      if (cookieValue) {
        let currentLang = options.filter(item => item.code.toLowerCase() === cookieValue.toLowerCase());
        if (currentLang && currentLang.length <= 0) {
          window.location.href = "/en/";
          return;
        }
        setCookie(marketCookieName, cookieValue.toLowerCase());
        window.location.href = "/" + cookieValue.toLowerCase() + "/";
      }
    }
  };

  let closeCTA = {
    width: "auto",
    iconName: fields.closeIcon,
    callback: () => {
      setCookie(marketCookieName, lang);
      changeMarketDetector(false);
    }
  };

  return isShow ? (
    <div className="market-detector grid" style={{ display: `${showMarketBanner ? "grid" : "none"}` }}>
      {fields.headingBody && (
        <Heading
          {...{
            html: fields.headingBody,
            className: "title",
            type: fields.headingType,
            typographyClass: "type-h4"
          }}
        />
      )}
      {fields.body && <RichText tag="div" field={fields.body} className={`body`} />}
      {marketsDropdown && (
        <div className="markets">
          <Dropdown {...marketsDropdown} />
        </div>
      )}
      {switchCTA && (
        <div className="switch-cta">
          <PrimaryButton {...switchCTA} />
        </div>
      )}

      {closeCTA && (
        <div className="close-cta">
          <PrimaryButton {...closeCTA} />
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};
const mapStateToProps = state => ({
  showMarketBanner: selectMarketBannerState(state)
});
const mapDispatchToProps = {
  changeMarketDetector: changeMarketDetector
};
export default connect(mapStateToProps, mapDispatchToProps)(MarketDetector);
